import { useState } from "react";
import { supabase } from "@/lib/supabaseClient";
import Button from "./ui/AppButton";

export default function MessageInput({ threadId }: { threadId: string }) {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);

  async function onSend() {
    if (!text.trim()) return;
    setSending(true);
    const { error } = await supabase.from("messages").insert({
      thread_id: threadId,
      sender_type: "sales",
      sender_name: "Test User",
      content: text
    });
    setSending(false);
    if (!error) setText("");
  }

  return (
    <div className="flex items-start gap-2">
      <textarea
        className="w-full border rounded-md p-2"
        rows={3}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Écrire un message..."
      />
      <Button disabled={sending} onClick={onSend}>Envoyer</Button>
    </div>
  );
}


